<div class="flex flex-col gap-4 rounded-[48px] border-2 border-background-white bg-background-modal px-6 py-4 backdrop-blur">
  <span class="typo-h2 text-center">
    {{ 'schedule_add_time_pattern_modal_title' | translate }}
  </span>

  <lib-time-pattern-editor [timePatterns]="dialogData.timePatterns" (timePatternChange)="updateTimePatterns($event)" />

  <div class="flex gap-10 self-end">
    <button type="button" class="btn-text" (click)="closeDialog()">{{ 'schedule_add_time_pattern_modal_cancel' | translate }}</button>
    <button type="button" class="btn-primary" (click)="saveTimePatterns()">
      {{ 'schedule_add_time_pattern_modal_save' | translate }}
    </button>
  </div>
</div>
